// extracted by mini-css-extract-plugin
export default {"message_box":"MessageBoxSimple_message_box__DFBDH","message":"MessageBoxSimple_message__qCU5l"};